import React from 'react'

export const HomeIcon = ({
  width = 20,
  height = 20,
  fill = '#282828'
}: {
  width?: number
  height?: number
  fill?: string
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill={fill}
    >
      <path
        d="M8.33333 16.6667V11.6667H11.6667V16.6667H15.8333V10H18.3333L10 2.5L1.66667 10H4.16667V16.6667H8.33333Z"
        fill={fill}
      />
    </svg>
  )
}
